import type { Relationships } from "@/types/model/Roles";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface userRelationshipsState {
  relationships: Relationships;
  setRelationships: (data: Relationships) => void;
}

export const useRelationshipsStore = create<userRelationshipsState>()(
  devtools(
    (set) => ({
      relationships: [],
      setRelationships: (data) => {
        return set(
          () => ({
            relationships: [...data],
          }));
      },
    }),
    {
      name: "RelationshipsStore",
    }
  )
);
